import { IPost } from '_interfaces/post.interface';
import { DraftButton } from '../draft-button/draft-button';
import { DraftDialog } from 'components/draft-dialog';
import { useModalState } from 'hooks/useModalState';

interface IDraftButtonWithDialog {
  drafts: IPost[];
}

export const DraftButtonWithDialog = ({ drafts }: IDraftButtonWithDialog) => {
  const [isOpen, onOpen, onClose] = useModalState();

  return (
    <>
      <DraftButton
        draftsCount={drafts.length}
        onClick={onOpen}
      />
      {isOpen && (
        <DraftDialog
          open={isOpen}
          drafts={drafts}
          onClose={onClose}
        />
      )}
    </>
  );
};
